import React, { useCallback, useEffect, useState } from 'react';
import { OUT_TRANSITION_TIME } from './constants';
import { useModalRender, ModalWrapperProps } from '../../lib';
import classNames from 'classnames';
import { Close } from '../Close';
import './Drawer.scss';
import CloseSecurityDrawerStore from '@widgets/BrokerLevelPositionsTabs/store/account-refresh-store';
import PopupOpenStateStore from '@widgets/BrokerLevelPositionsTabs/store/popup-open-store';
import CloseSingleSecurityDrawerStore from '@widgets/OrderTable/store/account-refresh-store';

export const Drawer: React.FC<ModalWrapperProps> = (props) => {
    const { close, Component, props: componentProps, modalId, closeClassName } = props;
    const { VerificationModal, shouldVerify, localStorageKey } = componentProps;
    const closeSecurityDrawer = CloseSecurityDrawerStore();
    const setIsDrawerOpen = PopupOpenStateStore((state) => state.setIsDrawerOpen);
    const closeSingleSecurityDrawer = CloseSingleSecurityDrawerStore();

    const { shown, closeClick, onBodyClick } = useModalRender({
        close,
        onClose: componentProps.onClose,
        outTransitionTime: OUT_TRANSITION_TIME,
        VerificationModal,
        shouldVerify,
        localStorageKey,
    });

    const onClose = useCallback(() => {
        setIsDrawerOpen(false);
        closeClick();
    }, [closeClick]);

    useEffect(() => {
        if (closeSecurityDrawer.isDrawerClosed) {
            closeClick();
            setIsDrawerOpen(false);
        }
    }, [closeSecurityDrawer, onClose, close, closeClick]);

    useEffect(() => {
        if (closeSingleSecurityDrawer.isDrawerClosed) {
            closeClick();
            setIsDrawerOpen(false);
        }
    }, [closeSingleSecurityDrawer, onClose, close, closeClick]);

    return (
        <div
            className={classNames('feature-modal-drawer', { shown })}
            onMouseDown={() => {
                closeClick();
                setIsDrawerOpen(false);
            }}
        >
            <section
                className={classNames('feature-modal-drawer__body')}
                onMouseDown={onBodyClick}
            >
                <Close
                    close={onClose}
                    className={closeClassName}
                />
                <Component
                    {...componentProps}
                    onClose={closeClick}
                    id={modalId}
                />
            </section>
        </div>
    );
};
